import ReactGA from 'react-ga4';
import { ampli } from '../../../../ampli';
import { BottomFloatingButton } from '../../../../components/common/buttons/FloatingButtons/BottomFloatingButton';
import { useNavigate } from 'react-router-dom';

export const CreateOwnTractorButton = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    ampli.pvmClickOwnTractorButton();
    ReactGA.event('pvm_click_own_tractor_button', {
      category: 'myInfo',
      action: 'pvm_click_own_tractor_button',
    });
    navigate('/survey/entry/own-tractor');
  };

  return <BottomFloatingButton handleButtonClick={handleButtonClick} title={'보유 트랙터 등록'} />;
};
